module.exports = __webpack_public_path__ + "img/wf-finishing-position-1.0148cae6.svg";